<ng-container style="width:100%">
<span class="error-message" [class.hide]="_hide">
                                {{_text | dyTranslate}}
                            </span>
</ng-container>
